// extracted by mini-css-extract-plugin
module.exports = {"title":"_284e3","label":"d1321","tagline":"_1b50f","options":"_9e9ab","active":"_2d687","select":"_1f4e2","footer":"_1b2d0"};